<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 점검정보 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 점검정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>점검일</div>
          <p v-if="isPrint" class="print-input">{{ form.점검일 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.점검일" />
        </div>
      </div>
    </div>

    <!-- 안전보건관계법령 점검결과 -->
    <table-custom
      ref="inspection"
      :board="board"
      :is-print="isPrint"
      title="안전보건관계법령 점검결과"
      :tableData="[
        { id: 'input1', title: '해당 법령명', type: 'text', max: 500 },
        { id: 'input2', title: '이행', type: 'number', afterText: '건', width: '200px', textAlign: 'right' },
        { id: 'input3', title: '보완필요', type: 'number', afterText: '건', width: '200px', textAlign: 'right' },
        { id: 'input4', title: '비고(보완내역)', type: 'customType', width: '400px' },
      ]"
      :mobile="['input1']"
      v-model="form.inspection"
    >
      <template #customType="{ trData, value, input }">
        <ml-input v-if="trData && 0 < trData.input3" :readonly="board.readonly" :value="value" @input="(e) => input(e)" visibleCounter :max="2000" />
      </template>

      <template #customTr>
        <tr style="background: #f9f9f9 !important" class="hidden xl:table-row">
          <td></td>
          <td class="text-center font-medium" style="padding: 15px 0 14px">소계</td>
          <td class="text-center font-medium" style="padding: 15px 0 14px">{{ form.이행총계 | comma }}</td>
          <td class="text-center font-medium" style="padding: 15px 0 14px">{{ form.보완필요총계 | comma }}</td>
          <td></td>
        </tr>
      </template>
    </table-custom>

    <!-- 파일첨부 -->
    <file-upload-module class="mt-28px" :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import Print from "./Print.vue";

export default {
  components: {
    FieldSelectModule,
    DateSelector,
    TableCustom,
    FileUploadModule,
    Print,
  },
  filters: {
    comma(str) {
      return `${str}`.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  props: {
    isPrint: Boolean,
    header: Object,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},
        점검일: "",
        inspection: [],
        이행총계: 0,
        보완필요총계: 0,
        fileList: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    "form.점검일": {
      immediate: true,
      handler(value) {
        if (value) {
          const date = new Date(value);
          const year = date.getFullYear();
          const month = date.getMonth() + 1;
          this.header.year = year;
          this.header.month = month;
          this.header.date = value;
          this.header.full = value;
          this.header.quarter = Math.floor((month - 1) / 3) + 1;
          this.header.half = month <= 6 ? "상반기" : "하반기";
        }
      },
    },
    "form.inspection": {
      immediate: true,
      deep: true,
      handler(value) {
        if (this.$refs.inspection && value.length < 1) {
          this.$refs.inspection.handleAddRow();
        }
        let _이행총계 = 0;
        let _보완필요총계 = 0;
        value.map((_item) => {
          _이행총계 += Number(_item.input2);
          _보완필요총계 += Number(_item.input3);
        });
        this.form.이행총계 = _이행총계;
        this.form.보완필요총계 = _보완필요총계;
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.tinput {
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.7rem !important;
  font-size: 1rem !important;
  border-radius: 5px;
}
</style>
